import React from "react";
import Navbar from "react-bootstrap/Navbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import globals from 'assets/globals.json';
import ecorisQLogo from 'assets/logoEcorisQ.png';

export default function NavBar() {
  const [showModal, setShowModal] = React.useState(false);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);


  const [gitVersion, setGitVersion] = React.useState("(Loading Module)");

  React.useEffect(() => {
    console.log("Getting git version...");

    // @ts-ignore
    if (window.WASMApplcationModule != undefined) {
      // @ts-ignore
      window.CreateWASMApplication().then((Module) => {
        const git_version = Module.GetGitCommitHash();
        console.log("Git Version", git_version);
        setGitVersion(git_version);
      });
    }

    // @ts-ignore
  }, [window.WASMApplcationModule]);

  return (
    <Navbar bg="dark" variant="dark" className="justify-content-between">
      <Navbar.Brand>
        {globals.application_name}
        <span style={{ fontSize: "smaller" }}> by </span>
        <img
          alt="ecorisQ Logo"
          src={ecorisQLogo}
          height="25"
          className="d-inline-block align-top"
        />
      </Navbar.Brand>
      <Button
        variant="dark"
        className="d-inline-flex align-items-center"
        onClick={handleShow}
        title="About"
      >
        <FontAwesomeIcon icon={faInfoCircle} />
      </Button>

      {showModal &&
        <Modal show={showModal} onHide={handleClose}>
          <Modal.Header>
            <Modal.Title>About {globals.application_name} {globals.version}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p>Version information:</p>
            <ul>
              <li>{globals.application_name} {globals.version}</li>
              <li>SlideforNET {gitVersion}</li>
            </ul>
            <p>
              Copyright (c) 2023-2025 CoSci LLC, USA
              <br />
              &lt;software@cosci-llc.com&gt;
            </p>

            <p>
              End user license agreement located <a href="/eula.html">here</a>
            </p>

            <p>
              Full copyright and attributions located <a href="/copyright.html">here</a>
            </p>
          </Modal.Body>

          <Modal.Footer>
            <Button onClick={handleClose} variant="primary">
              Close
            </Button>
          </Modal.Footer>
        </Modal>}
    </Navbar>
  );
}
